module.exports = __webpack_public_path__ + "static/media/customized-titles.64b07b8d.pdf";